import { CHARGE_SELECTION_MODE, CustomerTypes, CycleType } from "../../../../constants/app-constants";
import { DynamicFromDataType } from "../../../../constants/dynamic-from-data-type";
import { DynamicForm } from "../../../../models/dynamic-form";

export const ContainerInvoiceFromControlNames = {
  INVOICE_DATE: 'invoiceDate',
  VALID_TILL: 'validTill',
  CUSTOMER_ID: 'customerId',
  CYCLE: 'cycle',
  BILLING_MODE: 'billingMode',
  CHARGE_GROUP_ID: 'chargeGroupId',
  CHARGE_SELECTION_MODE: 'chargeSelectionMode',
  BILLING_PARTY: 'billingPartyId',
  BILLING_PARTY_TYPE: 'billingPartyType',
  CONTAINER: 'containerIds',
  BILLING_ADDRESS: 'billingAddressId',
  DATE_RANGE: 'dateRange',
  DATE_RANGE_START: 'from',
  DATE_RANGE_END: 'to',
  PAYING_PARTY_ID: 'payingPartyId'
}

export const ContainerInvoiceBillingMode = {
  CONTAINER: 'CONTAINER',
  PERIODIC_CHARGE: 'PERIODIC_CHARGE'
} as const;

export const ContainerInvoiceFormConfig: DynamicForm = {
  "formName": "Create Container Invoice",
  "formRows": [
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.INVOICE_DATE,
            "displayLabel": "Billing Date",
            "disabled": false,
            "placeHolder": "Select Billing Date",
            "fieldInfo": {
              "dataType": "date",
              "defaultToCurrentDate": true
            },
            "permissionConditions": {
              "readOnly": {
                "type": "any",
                "permissionIds": [
                  "FIELD_INVOICES_EDIT_BILLING_DATE"
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Date is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.VALID_TILL,
            "displayLabel": "Valid Till",
            "disabled": false,
            "placeHolder": "Select Validity Date",
            "fieldInfo": {
              "dataType": "date"
            },
            "validators": [
              {
                "type": "required",
                "message": "Valid Till is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.CUSTOMER_ID,
            "displayLabel": "Customer",
            "disabled": false,
            "placeHolder": "Select Customer",
            "returnRawValue": true,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Customer is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.CYCLE,
            "displayLabel": "Cycle",
            "disabled": true,
            "hidden": true,
            "defaultValue": CycleType.EMPTY.key,
            "placeHolder": "Cycle",
            "fieldInfo": {
              "dataType": "select",
              "options": [CycleType.EMPTY],
              displayKey: 'value',
              valueKey: 'key'
            },
            "validators": [
              {
                "type": "selectRequired",
                "message": "Cycle is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.DATE_RANGE,
            "displayLabel": "Gate Out Date Range",
            "fieldInfo": {
              "dataType": DynamicFromDataType.DATE_RANGE
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.CONTAINER,
            "displayLabel": "Empty Container",
            "disabled": false,
            "placeHolder": "Select Empty Container",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v2/containers/list",
                "filterByKeys": [
                  "CONTAINER_NO_CONTAINS"
                ],
                multiSelect: true,
                "additionalFilters": [
                  {
                    "name": "CYCLE_EQUALS",
                    "alias": "cycle",
                    "value": [
                      CycleType.EMPTY.key
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "containerNo",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "containerNo",
                    "header": "Container Number"
                  },
                  {
                    "key": "containerSize",
                    "header": "Size"
                  },
                  {
                    "key": "containerType",
                    "header": "Type"
                  }
                ]
              }
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  {
                    "field": ContainerInvoiceFromControlNames.CUSTOMER_ID,
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.CHARGE_GROUP_ID,
            "displayLabel": "Charge Group",
            "disabled": false,
            returnRawValue: true,
            "placeHolder": "Select Charge Group",
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/charge-groups/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Charge Group is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.CHARGE_SELECTION_MODE,
            "displayLabel": "Charge Selection Mode",
            "placeHolder": "Select Charge Selection Mode",
            "fieldInfo": {
              "dataType": "select",
              "options": Object.values(CHARGE_SELECTION_MODE),
              displayKey: 'label',
              valueKey: 'value'
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.BILLING_PARTY,
            "displayLabel": "Billing Party",
            "disabled": false,
            "placeHolder": "Select Billing Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Billing Party is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.BILLING_PARTY_TYPE,
            "displayLabel": "Billing Party Type",
            "disabled": false,
            "placeHolder": "Select Billing Party Type",
            "fieldInfo": {
              "dataType": "select",
              "options": Object.values(CustomerTypes),
              displayKey: 'name',
              valueKey: 'value'
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.BILLING_ADDRESS,
            "displayLabel": "Billing Address",
            "disabled": false,
            "placeHolder": "Enter Billing Address",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "select",
              "options": [],
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "billingPartyId",
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Address is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "paymentTerm",
            "displayLabel": "Payment Term",
            "disabled": false,
            "placeHolder": "Select Payment Term",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Cash/Immediate",
                  "value": "CASH"
                },
                {
                  "label": "Credit",
                  "value": "CREDIT"
                },
                {
                  "label": "PDA",
                  "value": "PDA"
                }
              ]
            },
            "validators": [
              {
                "type": "required",
                "message": "Payment Term is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": ContainerInvoiceFromControlNames.PAYING_PARTY_ID,
            "displayLabel": "Paying Party",
            "disabled": false,
            "placeHolder": "Select Paying Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "paymentTerm",
                    "operator": "EQUALS",
                    "value": "PDA"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Paying Party is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [

      ]
    }
  ]
}
